<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import SalesCommissionParticipantGroupControls from './SalesCommissionParticipantGroupControls.vue';
import SalesCommissionParticipantRows from './SalesCommissionParticipantRows.vue';
import {
  participantArticle,
  participantGroupLabel,
} from '../composables/salesCommissionParticipantLabels';

const props = defineProps({
  banks: { type: Array, default: () => [] },
  errors: { type: Object, default: () => ({}) },
  group: { type: String, required: true },
  options: { type: Array, default: () => [] },
  pixKeys: { type: Array, default: () => [] },
  reportTypes: { type: Array, default: () => [] },
  value: { type: Object, required: true },
});

const emit = defineEmits([
  'distributePercentages',
  'setCount',
  'toggleGroup',
  'updateGroup',
  'updateOptionistReport',
  'updateParticipant',
]);
const { t } = useI18n();
const enabled = computed(() => props.value.enabled !== false);
const plural = computed(() => (props.value.rows?.length || 0) > 1);
const heading = computed(() =>
  t('SALES.COMMISSION.PARTICIPANTS.TITLE', {
    article: participantArticle(t, plural.value),
    role: participantGroupLabel(t, props.group, plural.value),
  })
);
</script>

<template>
  <LaisCard :title="heading" prefix-icon="i-lucide-users-round">
    <SalesCommissionParticipantGroupControls
      :group="group"
      :value="value"
      :errors="errors"
      :report-types="reportTypes"
      @distribute-percentages="group => emit('distributePercentages', group)"
      @set-count="(group, count) => emit('setCount', group, count)"
      @toggle-group="(group, value) => emit('toggleGroup', group, value)"
      @update-group="
        (group, field, value) => emit('updateGroup', group, field, value)
      "
      @update-optionist-report="value => emit('updateOptionistReport', value)"
    />
    <p
      v-if="enabled && !value.rows?.length"
      class="mt-5 text-sm text-lais-text-muted"
    >
      {{ t('SALES.COMMISSION.PARTICIPANTS.EMPTY') }}
    </p>
    <SalesCommissionParticipantRows
      v-else-if="enabled"
      class="mt-1"
      :value="value"
      :group="group"
      :options="options"
      :banks="banks"
      :pix-keys="pixKeys"
      :errors="errors"
      @update-participant="(...args) => emit('updateParticipant', ...args)"
    />
  </LaisCard>
</template>
